import {Service} from 'typedi';
import {StrategyBuilder} from '../../StrategyBuilder';

import {makeLogger} from '../../../../logger/logger';
import type {InternalAddressesStrategyData} from '../../types/internal-addresses-strategy-data.type';
import {InternalAddressesStrategyService} from '../../InternalAddressesStrategyService';

const {err} = makeLogger({pathToCurrentFile: 'components/strategies/services/internal-address-services/internal-address-faqs.service.ts'});

@Service({id: 'internalAddressesB2cStrategyService'})
export class FallbackStrategyServiceBuilder extends StrategyBuilder<InternalAddressesStrategyService> {

  build(details: InternalAddressesStrategyData): InternalAddressesStrategyService {
      return new InternalAddressesStrategyB2c(details);
  }
}

export class InternalAddressesStrategyB2c extends InternalAddressesStrategyService {
  details;

  constructor(details: InternalAddressesStrategyData) {
      super();
      this.details = details;
  }

  isExternalLink(link: string):boolean {
      try {
        const follow = new URL(link);

        const internalDomains = [
          'www.se.com',
          'se.com',
          'www.schneider-electric.com',
          'schneider-electric.com',
          'www.schneider-electric.cn',
          'schneider-electric.cn',
          'https://shop.se.com',
          'shop.se.com',
          'www.shop.se.com',
          'www-pre.se.com',
          'download-pp',
          'download-pp.dev.schneider-electric.com',
          'download.schneider-electric.com',
          'www.document.schneider-electric.fr'
        ];

        if (follow.hostname) {
          return (
            !internalDomains.includes(follow?.hostname) &&
                    window.location.hostname !== follow?.hostname
          );
        } else {
          return false;
        }
      } catch (e) {
        err('Encountered an unexpected problem while validating external links');
        return false;
      }
  }
}
